/* eslint-disable */
// @ts-nocheck
import React from 'react';
import { MockBadge } from './mock-badge.js';

// ─── M ─ metric tile (mockup line 2903) ───────────────────────────
export function M({
  label,
  value,
  sub,
  color = '#0FB7D1',
  tip = null,
  loading = false,
}: {
  label: React.ReactNode;
  value: React.ReactNode;
  sub?: React.ReactNode;
  color?: string;
  tip?: React.ReactNode;
  loading?: boolean;
}) {
  return (
    <div className={`cc-m ${tip ? 'metric-tip' : ''}`.trim()}>
      <div className={`cc-m-label ${loading ? 'loading-blur' : ''}`.trim()}>{label}</div>
      <div className={`cc-m-value ${loading ? 'loading-blur' : ''}`.trim()} style={{ color }}>
        {value}
      </div>
      {sub && <div className={`cc-m-sub ${loading ? 'loading-blur' : ''}`.trim()}>{sub}</div>}
      {tip && <span className="metric-tip-text">{tip}</span>}
    </div>
  );
}

// ─── Bar ─ progress bar (mockup line 2941) ────────────────────────
export function Bar({ pct, color = '#0FB7D1', h = 4 }) {
  return (
    <div className="cc-bar-track" style={{ height: h, borderRadius: h / 2 }}>
      <div
        className="cc-bar-fill"
        style={{ width: `${pct}%`, background: color, borderRadius: h / 2 }}
      />
    </div>
  );
}

// ─── SectionLabel (mockup line 3609) ──────────────────────────────
export function SectionLabel({ text }: { text: string }) {
  return <div className="cc-section-label">{text}</div>;
}

// ─── R ─ labelled row (mockup line 3622) ──────────────────────────
// `mock` prop appends a DEMO badge to the value when the field is known
// to be unbacked by live data.
export function R({ label, value, hl = false, warn = false, mock = false }) {
  const valueClass = warn
    ? 'cc-r-value cc-r-value--warn'
    : hl
      ? 'cc-r-value cc-r-value--hl'
      : 'cc-r-value';
  return (
    <div className="cc-r">
      <span className="cc-r-label">{label}</span>
      <span className={valueClass}>
        {value}
        {mock && <MockBadge />}
      </span>
    </div>
  );
}

// ─── FilterPill ─ labelled <select> pill (mockup line 4344) ───────
export function FilterPill({ label, value, options, onChange }) {
  return (
    <div className="cc-filter-pill">
      <span className="cc-filter-pill-label">{label}</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="cc-filter-pill-select"
      >
        {options.map((o) => (
          <option key={o.v} value={o.v} className="cc-filter-pill-option">
            {o.l}
          </option>
        ))}
      </select>
    </div>
  );
}
